import { render, staticRenderFns } from "./header.vue?vue&type=template&id=12835cef&scoped=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"
import style0 from "./header.vue?vue&type=style&index=0&id=12835cef&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12835cef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12835cef')) {
      api.createRecord('12835cef', component.options)
    } else {
      api.reload('12835cef', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=12835cef&scoped=true", function () {
      api.rerender('12835cef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/header.vue"
export default component.exports